<template>
  <main>
    <section class="character">
      <nuxt-link v-if="findAnime && char.anime[findAnime]" :to="`/watch/${char.anime[findAnime].id}/characters`" class="backlink">
        Персонажи из аниме {{ char.anime[findAnime].name_ru }}
      </nuxt-link>
      <span> &middot; </span>
      <nuxt-link :to="`${fullPath.replace('https://anime777.site', '')}/cosplay`">Косплей</nuxt-link>
      <span> &middot; </span>
      <nuxt-link :to="`${fullPath.replace('https://anime777.site', '')}/art`">Арты (Фото)</nuxt-link>
      <h1>{{ char.name }}</h1>

      <header class="character-header">
        <img :src="char.poster" :alt="char.name">
        <div>
          <h4>Имена</h4>
          <div v-html="char.names" />
        </div>
        <div>
          <h4>Сэйю</h4>
          <ul class="seyu">
            <li v-for="p in char.seyu" :key="`animegg-info-person-${p.id}`">
              <img :src="p.poster" :alt="p.name_ru">
              <strong class="name-ru">{{ p.name_ru }}</strong>
              <span class="name-en">{{ p.name_en }}</span>
            </li>
          </ul>
        </div>
      </header>

      <h2 v-if="char.description" style="margin-bottom: 10px;">Биография</h2>
      <div v-if="char.description" v-html="char.description" class="description" />

      <h3>Видео</h3>
      <button v-if="!showVideos" @click="showVideos = true" class="dbtn">Посмотреть видео</button>
      <amv-component v-else :text="`аниме персонаж ${char.name}`" />

      <h3>Арты</h3>
      <button v-if="!showArts" @click="showArts = true" class="dbtn">Посмотреть арты</button>
      <photos-component v-else :obj="{ text: `аниме персонаж ${char.name} арты`, page: 1 }" />

      <h3>Косплеи</h3>
      <button v-if="!showCosplays" @click="showCosplays = true" class="dbtn">Посмотреть косплеи</button>
      <photos-component v-else :obj="{ text: `аниме персонаж ${char.name} косплей`, page: 1 }" />

      <h3>Замечен в аниме</h3>
      <ul class="animes">
        <li v-for="a in char.anime" :key="`animegg-info-anime-${a.id}`">
          <nuxt-link :to="`/watch/sh${a.id}`">
            <img :src="a.poster" :alt="a.name_ru">
            <strong v-if="a.name_ru.length > 50" class="name-ru">{{ a.name_ru.slice(0, 50) }}...</strong>
            <strong v-else class="name-ru">{{ a.name_ru }}</strong>
            <span v-if="a.name_en.length > 50" class="name-en">{{ a.name_en.slice(0, 50) }}...</span>
            <span v-else class="name-en">{{ a.name_en }}</span>
          </nuxt-link>
        </li>
      </ul>
    </section>

    <client-only>
      <comments-component
        v-if="showComments"
        :id="`characters-${char.id}`"
        class="comments"
      />
      <div v-else class="comments" />
    </client-only>
  </main>
</template>

<script>
export default {
  components: {
    photosComponent: () => import('~/components/photosComponent.vue'),
    commentsComponent: () => import('~/components/commentsComponent.vue'),
    amvComponent: () => import('~/components/amvComponent.vue')
  },
  head() {
    const char = this.char
    const anime = char.anime && char.anime.length
      ? ` из аниме ${char.anime[0].name_ru}`
      : ''
    if (char) {
      return {
        title: `${char.name}${anime}`,
        link: [
          {
            hid: 'canonical',
            rel: 'canonical',
            href: this.fullPath
          }
        ],
        meta: [
          {
            hid: 'keywords',
            name: 'keywords',
            content: `${char.name}${anime} биография фото сэйю видео`
          },
          {
            hid: 'description',
            name: 'description',
            content: `Расскажем вам все что знаем об персонаже ${char.name}${anime}: биография, имена, сэйю, видео.`
          },
          {
            hid: 'og:url',
            property: 'og:url',
            content: this.fullPath
          },
          {
            hid: 'og:tags',
            property: 'og:tags',
            content: `${char.name}${anime} биография фото сэйю видео`
          },
          {
            hid: 'og:type',
            property: 'og:type',
            content: 'article'
          },
          {
            hid: 'og:title',
            property: 'og:title',
            content: `${char.name}${anime}`
          },
          {
            hid: 'og:description',
            name: 'og:description',
            content: `Расскажем вам все что знаем об персонаже ${char.name}${anime}: биография, имена, сэйю, видео.`
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: char.poster
          },
          {
            hid: 'twitter:title',
            property: 'twitter:title',
            content: `${char.name}${anime}`
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: `Расскажем вам все что знаем об персонаже ${char.name}${anime}: биография, имена, сэйю, видео.`
          },
          {
            hid: 'twitter:image',
            property: 'twitter:image',
            content: char.poster
          }
        ],
        script: [
          {
            type: 'application/ld+json',
            innerHTML: `
{
  "@context": "https://schema.org",
  "@type": "Person",
  "name": "${this.char.name}",
  "image": "${this.char.poster}"
}`
          }
        ],
        __dangerouslyDisableSanitizers: ['script']
      }
    }
  },
  computed: {
    fullPath() {
      const name = this.char.name.includes('/') >= 0
        ? this.char.name.toLowerCase().slice(this.char.name.indexOf('/') + 1).replace(/[^a-z]/g,'-').replace(/-{2,}/g,'-')
        : `-${this.char.name.toLowerCase()}`
      return `https://anime777.site/characters/${this.char.id}${name}`
    }
  },
  async asyncData({ query, params, $axios, error }) {
    const body = {
      id: params.id,
      link: `https://shikimori.one/characters/${params.id}`
    }
    const
    { data } = await $axios.post(`/api/charinfo`, body)
    if (data.error) {
      error(data.error)
      return
    }

    let findAnime = 0

    if (query.anime && data.anime && data.anime.length) {
      const findIndex = data.anime.findIndex(el => `sh${el.id}` === query.anime)
      if (findIndex >= 0 ) findAnime = findIndex
    }

    return {
      char: data,
      showComments: false,
      showVideos: false,
      showArts: false,
      showCosplays: false,
      findAnime
    }
  },
  mounted() {
    // window.addEventListener('scroll', this.getVideos)
    window.addEventListener('scroll', this.getComments)
    document.body.style.overflow = ''
  },
  methods: {
    getComments() {
      const doc = document.documentElement.clientHeight
      const comments = document.querySelector('.comments')
      if (comments) {
        const visible = doc - comments.getBoundingClientRect().top
        // console.log('comments', visible)
        if (visible > 0 && !this.commentsI) {
          ++this.commentsI
          this.showComments = true
        } else if(this.commentsI) {
          window.removeEventListener('scroll', this.getComments)
        }
      }
    }
  }
}
</script>

<style lang="stylus">
.character
  .line-container
    a
      margin-right 10px
    .line div
      display inline-block
      &.value
        font-weight bold
        margin-left 5px
  .character-header
    display grid
    grid-template-columns 225px 1fr 1fr
    grid-gap 20px
    margin 40px 0 30px
  .additional-links
    margin-top 20px
  h4
    margin-bottom 10px
    padding 5px 10px
    background #f1f1f1
  h3
    margin 30px 0 20px
    padding 5px 10px
    background #f1f1f1
  .description
    margin-bottom 30px
    .b-list
      margin-left 20px
  ul.seyu, ul.animes
    list-style none
    margin 10px 0
    display grid
    grid-template-columns repeat(auto-fit, 100px)
    grid-gap 30px 10px
    li
      display inline-block
      font-size 1.4rem
      cursor pointer
      overflow hidden
      a
        border none
      img
        width 100%
      strong
        display block
      span
        font-weight normal
</style>
